import LoadingGif from '../../assets/gif/loading.gif'
import './index.css'

export default function Loading() {
  return (
    <div className="loading-wrapper">
      <img className="loading-image" src={LoadingGif} alt="" />
    </div>
  )
}
